/* global jQuery, document, once, drupalSettings */
import map from 'lodash/fp/map';
import hoverintent from 'hoverintent';
import mainMenu from './ilcm.main-menu';

(($, Drupal) => {
  /* global window, Drupal */
  /* eslint-disable no-param-reassign */
  Drupal.behaviors.ilcm_theme = {
    attach: (context) => {
      once('ilcm_theme', 'body').forEach(() => {

        // Move modals to the end of the body to avoid z-index issues.
        const bsModals = document.querySelectorAll('.modal');
        map(modal => document.body.appendChild(modal), bsModals);

        /**************************************************************************
         * Prevent contextual links inside linked cards from activating parent link.
         **************************************************************************/

        setTimeout(function () {
          document.querySelectorAll('a.contextual-region').forEach((cardLink) => {
            cardLink.addEventListener('click', (e) => {
              // Clicking the contextual trigger should open the menu, not follow the card link.
              if (e.target.closest('.contextual .trigger')) {
                e.preventDefault();
                return;
              }

              // Clicking an actual contextual action link should follow that link,
              // not the parent card link.
              if (e.target.closest('.contextual-links a')) {
                e.stopPropagation();
              }
            });
          });
        }, 600);

        /**************************************************************************
         * Keeps focus trapped in the modal so user can only tab to input, search, and close.
         **************************************************************************/
        $('#overlay-search').on('shown.bs.modal', function () {
          const $modal = $(this);
          const focusableSelectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
          const $focusableElements = $modal.find(focusableSelectors).filter(':visible');
          const firstElement = $focusableElements[0];
          const lastElement = $focusableElements[$focusableElements.length - 1];

          // Focus the input field initially
          $modal.find('input.form-search').trigger('focus');

          // Trap focus within modal
          $modal.on('keydown.trapFocus', function (e) {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                  e.preventDefault();
                  lastElement.focus();
                }
              } else {
                // Tab
                if (document.activeElement === lastElement) {
                  e.preventDefault();
                  firstElement.focus();
                }
              }
            }
          });
        });

        $('#overlay-search').on('hidden.bs.modal', function () {
          $(this).off('keydown.trapFocus'); // Clean up event when modal closes
        });

        /**************************************************************************
         * Add collapsed class to accordion, reference, and agenda buttons by default.
         **************************************************************************/
        $('.paragraph--type-accordion button.accordion-button').each(function () {
          $(this).addClass('collapsed');
        });

        setTimeout(() => {
          mainMenu($);
        }, 500);


        // Main menu hovers and keyboard accessibility
        const dropdowns = document.querySelectorAll('.menu--main .dropdown');

        dropdowns.forEach((item) => {
          const trigger = item.querySelector('.dropdown-toggle');
          const menu = item.querySelector('.dropdown-menu');

          if (!trigger || !menu) return;
          const links = menu.querySelectorAll('a');
          const hideMenu = () => {
            menu.classList.remove('show');
            item.classList.remove('show');
            trigger.setAttribute('aria-expanded', 'false');
          };

          const showMenu = () => {
            menu.classList.add('show');
            item.classList.add('show');
            trigger.setAttribute('aria-expanded', 'true');

            // blur other dropdown triggers
            dropdowns.forEach((dropdown) => {
              if (dropdown !== item) {
                dropdown.querySelector('.dropdown-toggle')?.blur();
              }
            });
          };

          // Hovers (keep your existing util)
          hoverintent(item, showMenu, hideMenu);

          // Trigger keyboard controls
          trigger.addEventListener('keydown', (evt) => {
            switch (evt.key) {
              case 'Enter':
              case ' ':
              case 'ArrowDown':
                evt.preventDefault();
                evt.stopPropagation();
                showMenu();
                links[0]?.focus();
                break;

              case 'ArrowUp':
                evt.preventDefault();
                evt.stopPropagation();
                showMenu();
                links[links.length - 1]?.focus();
                break;
            }
          });

          // ESC closes menu
          item.addEventListener('keydown', (evt) => {
            if (evt.key === 'Escape') {
              hideMenu();
              trigger.focus();
            }
          });

          // Focus management (top level)
          trigger.addEventListener('focus', () => {
            dropdowns.forEach((dropdown) => {
              if (dropdown !== item) {
                const m = dropdown.querySelector('.dropdown-menu');
                const t = dropdown.querySelector('.dropdown-toggle');

                m?.classList.remove('show');
                dropdown.classList.remove('show');
                t?.setAttribute('aria-expanded', 'false');
              }
            });
          });

          // Dropdown link navigation
          links.forEach((link, index) => {
            link.addEventListener('keydown', (evt) => {
              const items = links;

              switch (evt.key) {
                case 'ArrowDown':
                  evt.preventDefault();
                  items[index + 1]?.focus();
                  break;

                case 'ArrowUp':
                  evt.preventDefault();
                  if (index === 0) {
                    hideMenu();
                    trigger.focus();
                  } else {
                    items[index - 1]?.focus();
                  }
                  break;

                case 'ArrowLeft': {
                  evt.preventDefault();
                  const prevDropdown = item.previousElementSibling;

                  if (prevDropdown?.classList.contains('dropdown')) {
                    prevDropdown.querySelector('.dropdown-toggle')?.focus();
                  } else {
                    hideMenu();
                    document.querySelector('.navbar-brand')?.focus();
                  }
                  break;
                }

                case 'ArrowRight': {
                  evt.preventDefault();
                  const nextDropdown = item.nextElementSibling;

                  if (nextDropdown?.classList.contains('dropdown')) {
                    nextDropdown.querySelector('.dropdown-toggle')?.focus();
                  } else {
                    nextDropdown?.querySelector('.menu-level-0')?.focus();
                  }
                  break;
                }
              }
            });
          });
        });

        // Top-level link behavior (non-dropdown items)
        const firstTopLink = document.querySelector('.menu-level-0');
        if (firstTopLink) {
          firstTopLink.addEventListener('focus', () => {
            document.querySelectorAll('.dropdown').forEach((dropdown) => {
              dropdown.classList.remove('show');
              dropdown.querySelector('.dropdown-menu')?.classList.remove('show');
              dropdown.querySelector('.dropdown-toggle')?.setAttribute('aria-expanded', 'false');
            });
          });
        }

        // Arrow navigation on top-level items
        const topLevelLinks = document.querySelectorAll('.menu-level-0');

        topLevelLinks.forEach((link) => {
          link.addEventListener('keydown', (evt) => {
            switch (evt.key) {
              case 'ArrowLeft':
                evt.preventDefault();
                link.closest('.nav-item')?.previousElementSibling
                  ?.querySelector('.menu-level-0')
                  ?.focus();
                break;

              case 'ArrowRight':
                evt.preventDefault();
                link.closest('.nav-item')?.nextElementSibling
                  ?.querySelector('.menu-level-0')
                  ?.focus();
                break;
            }
          });
        });

        /**************************************************************************
         * Alerts - Entire alert bar acts as accessible toggle button
         **************************************************************************/
        $('#block-ilcm-theme-alertsblock .node--type-alert.node--view-mode-default').each(function () {

          $('body').addClass('has-alert');
          var $alert = $(this);
          $alert.addClass('initial-page-load');

          if (window.Cookies.get('alertHasAnimated')) {
            $alert.addClass('has-seen');
          } else {
            window.Cookies.set('alertHasAnimated', new Date(), { expires: 1 });
            $alert.addClass('has-not-seen');
          }

          var hasDismissed = document.cookie.indexOf('alert=1') !== -1;
          var $expanded = $alert.find('.field--name-field-teaser-text');

          if (hasDismissed) {
            $expanded.hide();
          } else {
            $alert.removeClass('initial-page-load');
            $alert.addClass('active');
            $alert.attr('aria-expanded', 'true');
            $('body').addClass('alert-active');
            $('html').addClass('no-scroll');
            $expanded.show();
          }

          $alert.attr({
            role: 'button',
            tabindex: '0',
            'aria-expanded': $alert.hasClass('active') ? 'true' : 'false'
          });

          var $titleWrapper = $alert.find('.field--name-node-title');

          if ($titleWrapper.find('.alert-more').length === 0) {
            $titleWrapper.append('<span class="alert-more" aria-hidden="true">Open</span>');
          }

          var $toggleText = $titleWrapper.find('.alert-more');

          // Set correct initial label
          if ($alert.hasClass('active')) {
            $toggleText.text('Close');
          }

          $('body').append('<div class="alert-overlay"></div>');

          var showAlert = function () {
            if (!$alert.hasClass('active')) {

              $alert.removeClass('initial-page-load');
              $alert.addClass('active');
              $alert.attr('aria-expanded', 'true');
              $toggleText.text('Close');
              window.scrollTo(0, 0);
              $('body').addClass('no-scroll alert-active');
              $('html').addClass('no-scroll');
              $expanded.stop(true, true).slideDown();

              var $focusables = $expanded.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])').filter(':visible');
              if ($focusables.length) {
                $focusables.first().focus();
              }
            }
          };

          var hideAlert = function () {
            if ($alert.hasClass('active')) {

              $alert.removeClass('initial-page-load active');
              $alert.attr('aria-expanded', 'false');
              $toggleText.text('Open');
              $('body').removeClass('no-scroll alert-active');
              $('html').removeClass('no-scroll');
              $expanded.stop(true, true).slideUp();
              // Persist dismissal cookie
              var date = new Date();
              date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
              document.cookie = "alert=1; expires=" + date.toUTCString() + "; path=/";

              $alert.focus();
            }
          };

          setTimeout(function () {
            $('.node--type-alert.node--view-mode-default').addClass('page-is-loaded');
          }, 600);

          $alert.on('click', function (evt) {
            if ($(evt.target).closest('.field--name-field-teaser-text').length) return;

            if ($alert.hasClass('active')) {
              hideAlert();
            } else {
              showAlert();
            }
          });

          $alert.on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if ($alert.hasClass('active')) {
                hideAlert();
              } else {
                showAlert();
              }
            }
          });

          $expanded.on('keydown', function (e) {
            if (e.key !== 'Tab') return;

            var $focusables = $expanded.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])').filter(':visible');
            if (!$focusables.length) return;

            var first = $focusables.first()[0];
            var last = $focusables.last()[0];

            if (!e.shiftKey && document.activeElement === last) {
              hideAlert();
            }

            if (e.shiftKey && document.activeElement === first) {
              hideAlert();
            }
          });

          document.body.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
              hideAlert();
            }
          });

          document.body.addEventListener('click', function (evt) {
            if ($('body').hasClass('alert-active')) {
              var $parent = $(evt.target).closest('.node--type-alert');
              if (!$parent.length) {
                hideAlert();
                evt.stopPropagation();
              }
            }
          });

          var setAlertHeight = function () {
            var alertHeight = $titleWrapper.height();
            if (alertHeight > 0) {
              document.body.style.setProperty('--ilcm-alert-height', (alertHeight + 25) + 'px');
            }
          };

          setTimeout(setAlertHeight, 500);
          window.addEventListener('resize', setAlertHeight);
        });

        /**************************************************************************
         * Safe Exit button
         **************************************************************************/
        const quickExit = once('quickExitQuickExit', '.quick-exit');
        const quickExitUrls = ['https://www.weather.com', 'https://news.google.com'];
        if (quickExit.length > 0) {
          quickExit.forEach(el => el.addEventListener('click', function (e) {
            e.preventDefault();
            // Open a new tab with a distraction page
            let randomIndex = Math.floor(Math.random() * quickExitUrls.length);
            const quickExitUrl = quickExitUrls[randomIndex];
            window.open(quickExitUrl, '_blank');

            // Replace the current tab with a distraction page
            if (randomIndex !== drupalSettings.quick_exit.exit_urls.length - 1) {
              randomIndex += 1;
            } else {
              randomIndex = 0;
            }
            const quickExitUrl2 = quickExitUrls[randomIndex];
            window.location.replace(quickExitUrl2);

            // Optionally, clear browsing history to further enhance privacy
            if (window.history && window.history.replaceState) {
              window.history.replaceState({}, document.title, window.location.href);
            }
          }));
        }

      });
    },
  };

})(jQuery, Drupal);
